<template>
  <div>
    <div style="padding-top: 8px">
      <ejs-tab heightAdjustMode='None'  ref="element" :selecting='customTabSelect'>
        <e-tabitems>
          <e-tabitem :header='headerText0' :content='content0'></e-tabitem>
          <e-tabitem :header='headerText1' :content='content1'></e-tabitem>
          <e-tabitem :header='headerText2' :content='content2'></e-tabitem>
        </e-tabitems>
      </ejs-tab>
    </div>
    <div id="calculator" style="display:none;">
      <CalculatorList v-bind:nodeParam='nodeParam'></CalculatorList>
    </div>
    <div id="systemKPI" style="display:none;">
      <SystemKPI v-bind:nodeParam='nodeParam'></SystemKPI>
    </div>
    <div id="customKPI" style="display:none;">
      <CustomKPI v-bind:nodeParam='nodeParam'></CustomKPI>
    </div>
  </div>
</template>

<script>
import CalculatorList from './calculatorList';
import SystemKPI from './systemKPI';
import CustomKPI from './customKPI';

export default {
  name: 'right',
  components: {
    CalculatorList,
    SystemKPI,
    CustomKPI,
  },
  props: {
    nodeParam: {
      netypeid: '',
      measureobjecttypecode: '',
      countertypeid: '',
      neversionid: '',
      text: {},
      isLeaf: false
    }
  },
  data() {
    return {
      headerText0: {
        text: `${this.$t('Pm.calculator')}`,
      },
      headerText1: {
        text: `${this.$t('Pm.system')}KPI`,
      },
      headerText2: {
        text: `${this.$t('Pm.custom')}KPI`,
      },
      content0: '#calculator',
      content1: '#systemKPI',
      content2: '#customKPI',
    };
  },
  methods: {
    customTabSelect(e) {
      if (e.isSwiped) {
        e.cancel = true;
      }
    }
  },
  mounted() {
  }
};
</script>
